import {
  ICONS_COLORS,
  MAIN_FILTER
} from "@/modules/Events/constants/EventConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import TooltipButton from "@/shared/components/TooltipButton/TooltipButton.vue";
import EventDocumentData from "../EventDocumentData/EventDocumentData.vue";
import Vuetify from "vuetify";
import "firebase/storage";
import { DocumentDTO } from "../../models/DocumentDTO";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  DOCUMENT,
  DOWNLOAD_ONLY_CATEGORY
} from "../../constants/DocumentConstants";
import { DocumentBasicData } from "../../models/DocumentBasicData";
import {
  IMG_TYPE_EXTENSIONS,
  VIDEO_TYPE_EXTENSIONS
} from "@/shared/constants/FileConstants";
import EventTitle from "@/modules/Events/components/EventTitle/EventTitle.vue";
import { Utils } from "@/shared/utils/utils";
import { DocumentService } from "../../services/DocumentService";
import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { CHAT_ACTIONS } from "@/modules/Home/components/ChatWindow/Constants/ChatWindow.constants";

Vue.use(Vuetify);

@Component({
  name: "DocumentCard",
  components: {
    TooltipButton,
    EventDocumentData,
    EventTitle
  }
})
export default class DocumentCard extends Vue {
  @Inject() documentService!: DocumentService;

  @Prop() private index!: number;
  @Prop() private documentData!: DocumentDTO;

  showInformation = false;
  isOffice = false;
  isOther = false;
  docValue = {};
  docType = "";
  previsualization = false;
  cardClass = STYLE_CLASSES.CARD;
  basicBtnClassRound = STYLE_CLASSES.BASIC_ROUND_BTN;

  DOCUMENT = MAIN_FILTER.DOCUMENT;
  ICONS_COLORS = ICONS_COLORS;
  DOWNLOAD_ONLY_CATEGORY = DOWNLOAD_ONLY_CATEGORY;

  async showPreview() {
    const downloadOnly =
      this.documentData.category._key == DOWNLOAD_ONLY_CATEGORY;
    const documentBasicData: DocumentBasicData = {
      documentName: this.documentData.fileName,
      documentURL: "",
      downloadOnly: downloadOnly
    };
    console.log("documentData", this.documentData);
    if (this.documentData.documentPath) {
      if (this.documentData.migrate) {
        const urls = await Utils.signUrl(
          this.documentService,
          this.documentData,
          this.documentData.userId as string
        );

        if (urls) {
          documentBasicData.documentURL = urls.signedUrl;
        }
        this.$emit(DOCUMENT.EVENT.SHOW, documentBasicData);
        return;
      }
      if (
        IMG_TYPE_EXTENSIONS.includes(this.documentData.type) ||
        VIDEO_TYPE_EXTENSIONS.includes(this.documentData.type) ||
        downloadOnly
      ) {
        documentBasicData.documentURL = this.documentData.documentPath;
      } else {
        // const encodedURI = encodeURIComponent(this.documentData.documentPath);
        documentBasicData.documentURL = this.documentData.documentPath; //`${GOOGLE_DRIVE_URL}${encodedURI}`;
      }

      this.$emit(DOCUMENT.EVENT.SHOW, documentBasicData);
    } else {
      Snackbar.popError(DOCUMENT.MESSAGE.EMPTY_URL);
    }
  }

  shareDocument() {
    this.$emit(DOCUMENT.EVENT.SHARE, this.index);
  }

  showDetails() {
    this.showInformation = true;
  }

  hideDetails() {
    this.showInformation = false;
  }

  editDocument() {
    this.$emit(DOCUMENT.EVENT.EDIT, this.index);
  }

  deleteDocument() {
    this.$emit(DOCUMENT.EVENT.DELETE, this.index);
  }

  summaryDocument() {
    console.log("documentData", this.documentData);
    this.$store.commit(STORE_CONSTANTS.CHAT_ACTION, {
      action: CHAT_ACTIONS.OPEN_CHAT,
      msgsStore: [
        {
          role: "user",
          content: `resumir el documento ${this.documentData.fileName}`,
          context: {
            documentId: this.documentData._key
          },
          functionCall: {
            name: "getDocumentSummary"
          }
        }
      ]
    });
  }
}
